import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import cx from 'clsx';
import Popover from 'antd/es/popover';

import {
  IconTwitter,
  IconGithub,
  IconDiscord,
  IconRcEmail,
  IconCopyEmail,
  IconDeBankSupport,
} from '@/assets/sidebar';
import { CopyButton } from '@/components';

import style from './index.module.css';

const emailAddress = 'hi@debank.com';

const debankSupportUrl = '/official/DeBank';

export const Footer = ({
  iconSize = 24,
  iconGap = 20,
  className,
}: {
  className?: string;
  iconSize?: number;
  iconGap?: number;
}) => {
  const { t } = useTranslation();

  const content = useMemo(
    () => (
      <div className={style.popContainer}>
        <a
          className={style.linkText}
          href={`mailto:${emailAddress}`}
          rel="noreferrer"
          target="_blank">
          {emailAddress}
        </a>
        <CopyButton text={emailAddress}>
          <IconCopyEmail className={style.emailCopy} />
        </CopyButton>
      </div>
    ),
    [],
  );

  const debankOfficialHelp = useMemo(
    () => (
      <div className={style.popContainer}>
        <a className={cx(style.linkText, style.mr0)} href={debankSupportUrl} rel="noreferrer">
          {t('Footer.qn9xjg')}
        </a>
      </div>
    ),
    [t],
  );

  return (
    <div className={cx(style.container, className)}>
      <a href={`https://github.com/DeBankDeFi/logo/tree/master/DeBank`} target={`_blank`}>
        {t('Footer.tvjtcs')}
      </a>
      <span className={style.line} />
      <span>{t('Footer.akhl7e')}</span>

      <div className={style.icons} style={{ gap: iconGap }}>
        <Popover content={debankOfficialHelp} placement="top">
          <a href={debankSupportUrl} rel="noopener nofollow noreferrer" className={style.snsIcon}>
            <IconDeBankSupport width={iconSize} height={iconSize} />
          </a>
        </Popover>
        <a
          href={'https://discordapp.com/invite/KYuj8DE'}
          target={'_blank'}
          rel="noopener nofollow noreferrer"
          className={style.snsIcon}>
          <IconDiscord width={iconSize} height={iconSize} />
        </a>
        <a
          href={'https://twitter.com/DebankDeFi'}
          target={'_blank'}
          rel="noopener nofollow noreferrer"
          className={style.snsIcon}>
          <IconTwitter width={iconSize} height={iconSize} />
        </a>
        <a
          href={'https://github.com/DeBankDeFi'}
          target={'_blank'}
          rel="noopener nofollow noreferrer"
          className={style.snsIcon}>
          <IconGithub width={iconSize} height={iconSize} />
        </a>
        <Popover content={content} placement="top" overlayClassName={style.emailHintContainer}>
          <div className={style.snsIcon}>
            <IconRcEmail width={iconSize} height={iconSize} />
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default Footer;
